import { render, staticRenderFns } from "./MetricCategoryForm.vue?vue&type=template&id=7b7ab682"
import script from "./MetricCategoryForm.vue?vue&type=script&lang=js"
export * from "./MetricCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports